
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppCommonModule } from '../common.module';
import { OffersComponent } from '../components/partner-home/offer/offers/offers.component';
import { DashboardViewComponent } from '../components/views/dashboard/view-dashboard.component';

@Component({
  selector: 'app-offers-page',
  templateUrl: './offers.page.html',
  styleUrls: ['./offers.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    DashboardViewComponent,
    OffersComponent,
  ],
})
export class OffersPage {

}
